import React, { useEffect,useState } from 'react'


import AddIcon from '@material-ui/icons/Add'
//import Button from '@material-ui/core/Button'
import { Button,Toaster, Position } from "@blueprintjs/core";
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import PropTypes from 'prop-types'
import Switch from '@material-ui/core/Switch'
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'
import '../mytoaster.css';

const initialMatiere = {
  matiere: '',
  code: '',
  age: 0,
  visits: 0,
  status: 'Hors ligne',
  progress: 0,
  subRows: undefined,
}

const AddUserDialogMatiere = props => {
  console.log(props);
  const [uMatiere, setMatiere] = useState(initialMatiere)
  const { addMatiereHandler } = props.addMatiereHandler
  const [open, setOpen] = React.useState(false)
  const [isValidCode, setisValidCode] = React.useState(false)

  useEffect(() => {
    console.log("mounted");
    setisValidCode(false);
  }, []);
  

  const [switchState, setSwitchState] = React.useState({
    addMultiple: false,
  })
 
  const handleSwitchChange = name => event => {
    setSwitchState({ ...switchState, [name]: event.target.checked })
  }

  const resetSwitch = () => {
    setSwitchState({ addMultiple: false })
  }

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    setMatiere(initialMatiere)
    setisValidCode(false);
    resetSwitch()
  }

  const handleAdd = event => {
    console.log(props);
    /*addMatiereHandler(uMatiere)
    setMatiere(initialMatiere)
    switchState.addMultiple ? setOpen(true) : setOpen(false)
    setisValidCode(false);*/
    handleSendCode(uMatiere.matiere,props.userid,"");
   
  }

  const handleChange = name => ({ target: { value } }) => {
    console.log(name)
    console.log(value)
    //setisValidCode(false)
    //if(value.length<=0)return;
    setMatiere({ ...uMatiere, [name]: value });
    setisValidCode(true);
    
    
  }
  const handleSendCode=function(matiere,userid,description)
{
  
  const toaster=Toaster.create({
    className: "my-toaster",
    position: Position.TOP_RIGHT,
  });
  setisValidCode(false);
  var xhr = new XMLHttpRequest();
        xhr.overrideMimeType("application/json");
        var formData = new FormData();
        formData.append('matiere', matiere);
        formData.append('id_enseignant', userid);
        formData.append('description', description);
      
        xhr.open('POST','/api/public/creatematiere')
       
        xhr.setRequestHeader("Content-Type", "application/json");

        //send the form data
        xhr.send(JSON.stringify(Object.fromEntries(formData)));

        xhr.onreadystatechange = function() {
            if (xhr.readyState == XMLHttpRequest.DONE) {
                          
             if(xhr.status==200) 
             { 
              setisValidCode(true);
              console.log(xhr.responseText);
               var jsonResponse = JSON.parse(xhr.responseText);
               console.log(jsonResponse);
              
               toaster.show( {message:"Matière "+ uMatiere.matiere + " créée"});
               uMatiere.code=jsonResponse;
               props.addMatiereHandler(uMatiere);
              // setIsConnected('none')
              // setNavFilesVisible('flex');
              // setIsConnected('none');
              // localStorage.setItem("nickname",jsonResponse.nickname);// JSON.stringify(name));
             }
             if(xhr.status==404) {toaster.show( {message:"erreur"});setisValidCode(true); }
             if(xhr.status==500) {toaster.show( {message:"erreur"}); }
             
             setisValidCode(false);
             setOpen(false);
            
            }
           
        }
  return //setisOpenLogin(false)
}
  return (
    <div>
      
      <Button style={{width:300}}onClick={handleClickOpen}>
      <Tooltip title="Ajouter">
        <IconButton aria-label="Ajouter" onClick={handleClickOpen}>
          <AddIcon />
        </IconButton>
      </Tooltip>
        Ajouter une matière</Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Ajouter une matière</DialogTitle>
        <DialogContent>
          <DialogContentText>Ajouter une matière pour donner un code à vos étudiants.</DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label="Saisir la matière"
            type="texte"
            fullWidth
            value={uMatiere.matiere}
            onChange={handleChange('matiere')}
          />
          {/*<TextField
            margin="dense"
            label="Last Name"
            type="text"
            fullWidth
            value={user.lastName}
            onChange={handleChange('lastName')}
          />
          <TextField
            margin="dense"
            label="Age"
            type="number"
            fullWidth
            value={user.age}
            onChange={handleChange('age')}
          />
          <TextField
            margin="dense"
            label="Visits"
            type="number"
            fullWidth
            value={user.visits}
            onChange={handleChange('visits')}
          />
          <TextField
            margin="dense"
            label="Status"
            type="text"
            fullWidth
            value={user.status}
            onChange={handleChange('status')}
          />
          <TextField
            margin="dense"
            label="Profile Progress"
            type="number"
            fullWidth
            value={user.progress}
            onChange={handleChange('progress')}
          />*/}
        </DialogContent>
        <DialogActions>
          <Tooltip title="Si vous avez plusieurs matières à saisir">
            <Switch
              checked={switchState.addMultiple}
              onChange={handleSwitchChange('addMultiple')}
              value="addMultiple"
              inputProps={{ 'aria-label': 'secondary checkbox' }}
            />
          </Tooltip>
          <Button onClick={handleClose} color="primary">
            Annuler
          </Button>
          <Button onClick={handleAdd} color="primary" disabled={!isValidCode}>
            Ajouter
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

AddUserDialogMatiere.propTypes = {
  addMatiereHandler: PropTypes.func.isRequired,
}

export default AddUserDialogMatiere
